import type { RetryOptions } from 'common/types';

export type MergeRetryOptionsParams = {
  baseRetryOptions: RetryOptions;
  retryOptionsToMerge?: Partial<RetryOptions>;
};

export const mergeRetryOptions = ({
  baseRetryOptions,
  retryOptionsToMerge,
}: MergeRetryOptionsParams): RetryOptions => {
  const merged = baseRetryOptions;

  const {
    retryDelay: newRetryDelay,
    maxRetries: newMaxRetries,
    getShouldRetry: newGetShouldRetry,
  } = retryOptionsToMerge ?? {};

  if (newRetryDelay) {
    merged.retryDelay = newRetryDelay;
  }

  if (newGetShouldRetry) {
    merged.getShouldRetry = newGetShouldRetry;
    delete merged.maxRetries;
    return merged;
  }

  if (newMaxRetries) {
    merged.maxRetries = newMaxRetries;
    delete merged.getShouldRetry;
    return merged;
  }

  return merged;
};
